<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>done</v-icon>Finalizar solicitudes </v-flex>
        <v-flex xs9> {{ form.nombre_unidad }} </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout>
              <v-flex xs6>
                <h4><strong>Listado de servidores publicos</strong></h4>
              </v-flex>
              <v-flex xs6>
                <v-menu open-on-hover buttom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card>
                    <v-card-text class="ayuda">
                      <v-layout>
                        <v-flex class="text-xs-center caption">
                          <strong>
                            <p><v-icon>help_outline</v-icon></p>
                            <p>Solo puede finalizar las solicitudes</p>
                            <p>
                              cuando todas las programaciones de los servidores
                              públicos
                            </p>
                            <p>
                              del listado hayan sido aprobados por sus
                              respectivos jefes
                            </p>
                          </strong>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="listado_funcionarios"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.servidor_publico }}
                    </td>
                    <td class="text-xs-center">
                      <v-chip
                        dark
                        :color="
                          props.item.id_estado_vacac_progra == 54
                            ? '#de95f9'
                            : props.item.id_estado_vacac_progra == 72
                            ? '#fa8449'
                            : '#FF3400'
                        "
                        >{{ props.item.estado }}</v-chip
                      >
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            @click.prevent="aprobarProgramacion()"
            :disabled="this.bandera_aprobacion==false"
            ><v-icon>done</v-icon>
            Aprobar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      form: {},
      headers: [
        { text: "Nombre", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ],
      bandera_aprobacion: true,
      user: this.$storage.get("user"),
      id_programacion: null
    };
  },
  mounted() {
    this.$bus.$on(
      "openDialogFinalizarProgramacionesFuncionarios",
      async item => {
        this.form = item;
        await this.cargarListadoFuncionario();
        this.dialog = true;
      }
    );
  },

  methods: {
    async cargarListadoFuncionario() {
      try {
        let contador_aprobadosRRHH=0;
        let res = [];
         let user = this.$storage.get("user");
        let p_item_jefe = this.$util.decodeString(this.$route.params.item_jefe);
        let p_tipo_jefe = this.$util.decodeString(this.$route.params.tipo_jefe);
        let p_gestion = this.$util.decodeString(this.$route.params.gestion);
        let p_id_unidad = this.$util.decodeString(this.$route.params.id_unidad);
        if (p_item_jefe) {
          if (p_tipo_jefe == "AUT") {
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad_jerarquicos(${p_id_unidad},${p_gestion},${user.id_persona})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          } else {
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${p_id_unidad},${p_gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          }
          res = res.runQuery.respuesta;
          this.listado_funcionarios = res;
          this.listado_funcionarios.forEach(element => {
            if (element.id_estado_vacac_progra == 72) {
              contador_aprobadosRRHH++;
            }
            if (
              element.id_estado_vacac_progra == 47 ||
              element.id_estado_vacac_progra == 22 ||
              element.id_estado_vacac_progra == 66 ||
              element.id_estado_vacac_progra == 51 ||
              element.id_estado_vacac_progra == 73 ||
              element.id_estado_vacac_progra == 74
            ) {
              this.bandera_aprobacion = false;
            }
          });
          if (contador_aprobadosRRHH == this.listado_funcionarios.length) {
            this.bandera_aprobacion = false;
          }
          
        }
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form={}
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogFinalizarProgramacionFuncionarios");
      this.dialog = false;
    },
    async aprobarProgramacion() {
      let respuesta;
      let resps = [];
      let user = this.$storage.get("user");
      let correcto = true;
      this.loading = true;
      let msj_error = false;
      let msj_contenido = null;
      try {
        for (let i = 0; i < this.listado_funcionarios.length; i++) {
          const element = this.listado_funcionarios[i];
          if (element.id_estado_vacac_progra == 54) {
            console.log(`
                query{
                  runQuery(consulta:"select vacaciones.fn_aprueba_vacacion_programada_por_rrhh(${parseInt(this.$util.decodeString(this.$route.params.gestion))},${element.id_persona},72,${user.id})"){
                    respuesta
                  }
                }
              `)
            respuesta = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"select vacaciones.fn_aprueba_vacacion_programada_por_rrhh(${parseInt(this.$util.decodeString(this.$route.params.gestion))},${element.id_persona},72,${user.id})"){
                    respuesta
                  }
                }
              `
            });
            console.log(respuesta.runQuery.respuesta[0].fn_aprueba_vacacion_programada_por_rrhh)
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_aprueba_vacacion_programada_por_rrhh;
            resps = respuesta.split("|");
            correcto = resps[0];
            if (correcto != "1") {
              msj_error = true;
              msj_contenido = resps[1];
            }
          }
        }
        if (msj_error == false) {
          this.$confirm("Solicitudes finalizadas exitosamente", () => {});
        } else {
          this.$confirm(msj_contenido, () => {});
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.close();
    }
  }
};
</script>

<style>
.ayuda {
  background: #7ae4db8f;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/FinalizarProgramacionesFuncionarios.vue